import { getBalanceByUserRequest } from 'features/users/api';
import { useQuery } from 'react-query';

export const usePartnerBalanceByUserQuery = (id: number) => {
  const result = useQuery(
    `partner-balance-by-user-${id}`,
    async () => {
      const { data } = await getBalanceByUserRequest(id);
      return data;
    },
    { staleTime: Infinity }
  );

  return result;
};
